import { Context, useContext } from 'react';

import { ProfileContext } from './profile.context';
import { ProfileContextType } from './types';

export const useProfile = () => {
  return useContext(ProfileContext as Context<ProfileContextType>);
};
